import { api as generatedApi } from 'gen/rtk-openapi'

export const TAG_TYPES = {
  inventoryCommodity: 'InventoryCommodity',
  inventoryMaterialType: 'InventoryMaterialType',
}

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: [TAG_TYPES.inventoryCommodity, TAG_TYPES.inventoryMaterialType],
  endpoints: {
    getInventorySummaryByCommodity: {
      providesTags: () => [{ type: TAG_TYPES.inventoryCommodity, id: 'LIST' }],
    },
    getInventoryCommodity: {
      providesTags: () => [{ type: TAG_TYPES.inventoryCommodity, id: 'LIST' }],
    },
    getInventorySummaryByCommodityId: {
      providesTags: () => [{ type: TAG_TYPES.inventoryCommodity, id: 'LIST' }],
    },
    getInventoryCommodityHandler: {
      providesTags: () => [{ type: TAG_TYPES.inventoryCommodity, id: 'LIST' }],
    },
    getInventoryByCommodity: {
      providesTags: () => [{ type: TAG_TYPES.inventoryCommodity, id: 'LIST' }],
    },
    getInventoryMaterialType: {
      providesTags: () => [
        { type: TAG_TYPES.inventoryMaterialType, id: 'LIST' },
        { type: TAG_TYPES.inventoryCommodity, id: 'LIST' },
      ],
    },
    getInventoryMaterialTypeByIds: {}, // POST
    getNegativeInventoryList: {
      providesTags: () => [
        { type: TAG_TYPES.inventoryMaterialType, id: 'LIST' },
        { type: TAG_TYPES.inventoryCommodity, id: 'LIST' },
      ],
    },
  },
})

export const useGetInventoryMaterialTypeLazyQuery = api.endpoints.getInventoryMaterialType.useLazyQuery
export const {
  useGetInventoryCommodityQuery,
  useGetInventorySummaryByCommodityQuery,
  useGetInventoryRegradesQuery,
  useGetInventorySummaryByCommodityIdQuery,
  useGetInventoryFinishedgoodsQuery,
  useGetInventoryPackinglistsQuery,
  useGetInventoryByCommodityQuery,
  useGetInventoryCommodityHandlerQuery,
  useGetInventoryMaterialTypeQuery,
  useGetInventoryMaterialTypeByIdsMutation,
  useGetNegativeInventoryListQuery,
} = api
